import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { PlayCircle, Video as VideoIcon } from "lucide-react";
import { api } from "@/lib/api";
import { VIDEO_GALLERY } from "@/constants/testIds";

export const VideoGallery = ({ sectionId = "videos" }) => {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api
      .get("/videos")
      .then((res) => setVideos(res.data))
      .catch(() => setVideos([]));
  }, []);

  if (videos.length === 0) return null;

  return (
    <section
      id={sectionId}
      data-testid={`${VIDEO_GALLERY.section}-${sectionId}`}
      className="py-24 md:py-32 px-6 md:px-10 max-w-7xl mx-auto"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mb-14"
      >
        <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-[#D97736] mb-4">
          Official Kennel Video
        </p>
        <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-[#0F2520]">
          Video by Raijada Kennel
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {videos.map((v, i) => (
          <motion.div
            key={v.id}
            data-testid={VIDEO_GALLERY.card(v.id)}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className={`relative rounded-[1.5rem] overflow-hidden shadow-lg bg-[#0F2520] ${i % 3 === 1 ? "md:mt-8" : ""}`}
          >
            {active === v.id ? (
              <video
                src={`${api.defaults.baseURL}/videos/${v.id}/stream`}
                poster={v.thumbnail_storage_path ? `${api.defaults.baseURL}/videos/${v.id}/thumbnail` : undefined}
                controls
                autoPlay
                className="w-full aspect-video bg-black"
              />
            ) : (
              <button
                onClick={() => setActive(v.id)}
                className="relative w-full aspect-video flex items-center justify-center group"
              >
                {v.thumbnail_storage_path ? (
                  <img
                    src={`${api.defaults.baseURL}/videos/${v.id}/thumbnail`}
                    alt={v.title}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                ) : (
                  <VideoIcon className="w-10 h-10 text-white/30 absolute" />
                )}
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors" />
                <PlayCircle className="w-16 h-16 text-white relative z-10 group-hover:scale-110 transition-transform" />
              </button>
            )}
            <div className="px-4 py-3">
              <p className="text-white font-medium text-sm">{v.title}</p>
              {v.description && <p className="text-white/60 text-xs mt-1 line-clamp-2">{v.description}</p>}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
